module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/hair_arrange-24a48015389ede29393aed24a972e58f.jpg";